import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaptchaDto, GrupaDziekanskaDto, KontaktControllerService, PowerFormularzFrom, StudiaPubliczneControllerService } from '@enauka/api-strona-glowna';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZeszytOnlineService {

  constructor(private kontaktControllerService: KontaktControllerService, private http: HttpClient,
    private studiaPubliczneControllerService: StudiaPubliczneControllerService) { }

  getCaptcha(): Observable<CaptchaDto> {
    return this.kontaktControllerService.generateCaptchaUsingGET();
  }

  wyslijFormularzKontaktowy(form: PowerFormularzFrom): Observable<null> {
    return this.kontaktControllerService.postFormularzInformacyjnyZeszytUsingPOST(form);
  }

  verifyCasToken(ticket: string): Observable<Object> {
    return this.http.get(`${this.kontaktControllerService.rootUrl}/passwordless`, {
      params: {
        ticket: ticket
      }
    });
  }

  getGrupyDziekanskie(hash: string): Observable<GrupaDziekanskaDto> {
    return this.studiaPubliczneControllerService.getGrupyDziekanskieUsingGET2(hash);
  }

}
